<template>
    <div class="action-premium-sales">
        <div class="profile-container">
            <img class="photo flex-wrap" :src="content.photo_url" @error="$event.target.src = $blankProfile" />
            <div class="profile">
                <img src="@/assets/images/premium_blue.svg" />
                <div class="name" v-html="`상담사 ${(content || {}).name}`" />
            </div>
        </div>
        <div class="hr" />
        <div class="message">
            <div
                class="message-mid"
                v-html="$translate('ACTION_PREMIUM_SALES_MESSAGE').replace('%s', (content || {}).name)"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ActionPremiumSales',
    props: ['message'],
    computed: {
        chat() {
            return this.$store.getters.chat
        },
        content() {
            return this.$mustParse(this.message.content) || {}
        },
        user() {
            return this.content.user || {}
        },
        profile() {
            return this.chat.user.profile
        },
    },
}
</script>

<style lang="scss" scoped>
.action-premium-sales {
    .profile-container,
    .question,
    .button-container {
        padding: 0 12px;
    }

    .hr {
        width: 100%;
        height: 1px;
        background: $grey-02;
        margin-top: 8px;
        margin-bottom: 12px;
    }

    .profile-container {
        display: flex;

        .photo {
            width: 44px;
            height: 44px;
            border-radius: 40%;
            border: solid 1px $grey-02;
            margin-right: 12px;
        }

        .profile {
            width: 100%;
            align-self: center;

            .name {
                font-size: 14px;
                height: 20px;
                color: black;

                @include f-medium;
            }

            .sub {
                display: flex;
                font-size: 12px;
                width: 100%;

                .job,
                .location {
                    height: 18px;
                    color: $grey-07;
                }
                .bar {
                    color: $grey-04;
                    margin-left: 4px;
                    margin-right: 4px;
                }
            }
        }

        .profile-btn {
            width: 36px;
            min-width: 36px;
            height: 36px;
            border-radius: 8px;
            background-color: $grey-02;
            display: flex;
            object-fit: contain;
            justify-content: center;
            align-items: center;
        }
    }

    .message {
        margin-left: 12px;

        .message-mid {
            font-size: 12px;
            line-height: 1.33;
            text-align: left;
            color: $grey-09;
            margin-bottom: 12px;
        }
    }
}
</style>
